import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import "../../styles/PageContainer.css";
import { fetchCategory } from "../../service/CategoryService";
import { fetchVendor } from "../../service/VendorService";
import { fetchProductImageByProductId } from "../../service/ProductImageService";
import { apiUrl } from "../../config";
import { verifyProductCode } from "../../service/ProductService";

const ProductForm = ({
  editIndex,
  handleSubmit,
  productForm,
  handleChange,
  handleClearChange,
  images,
  // setImages,
  handleImageChange,
  removeImage,
  makingAmount,
  wastageAmount,
  setMakingAmount,
  setWastageAmount,
  setIsTypingMaking,
  setIsTypingWastage,
  isCodeDuplicate,
  handleCodeBlur,
}) => {
  const [categories, setCategories] = useState([]);
  const [vendors, setVendors] = useState([]);

  // const [productImages, setProductImages] = useState([])

  // const displayImages = editIndex ? productImages : images
  const fetchData = async () => {
    try {
      const res = await fetchCategory();
      const res2 = await fetchVendor();

      const images = await fetchProductImageByProductId(productForm.id);
      // setProductImages(images)
      setCategories(res);
      setVendors(res2);
    } catch (error) {
      console.error("Error in fetching", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // useEffect(() => {
  // if (editIndex && productForm.id) {
  //   fetchProductImageByProductId(productForm.id)
  //     .then(setProductImages)
  //     .catch(console.error);
  // }
  // //  else {
  // //   setProductImages([]);
  // // }
  // }, [editIndex, productForm.id]);

  // const handleImageData = (image)=>{
  //   return apiUrl+'/'+image
  // }

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <Row className="">
          <Col md={4} className="mb-2">
            <Form.Group>
              <Form.Label>{"code"}</Form.Label>
              <Form.Control
                type="text"
                value={productForm.code}
                name="code"
                onChange={handleChange}
                onBlur={handleCodeBlur}
                required
                isInvalid={isCodeDuplicate}
              />
              <Form.Control.Feedback type="invalid">
                  Product code alread exists!
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={4} className=" mb-2">
            <Form.Group>
              <Form.Label>{"Name"}</Form.Label>
              <Form.Control
                type="text"
                value={productForm.name}
                name="name"
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
          <Col md={4} className="mb-2">
            <Form.Group>
              <Form.Label>{"Weight"}</Form.Label>
              <Form.Control
                type="text"
                value={productForm.weight}
                name="weight"
                required
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col md={4} className="mb-2">
            <Form.Group>
              <Form.Label>{"Purchase Rate"}</Form.Label>
              <Form.Control
                type="text"
                value={productForm.purchaseRate}
                name="purchaseRate"
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
          <Col md={4} className="mb-2">
            <Form.Group>
              <Form.Label>{"Making Charge"}</Form.Label>
              <div className="d-flex gap-2">
                <div className="input-group mb-2">
                  <Form.Control
                    type="text"
                    value={productForm.makingCharge}
                    required
                    name="makingCharge"
                    onChange={handleChange}
                  />
                  <span className="input-group-text">%</span>
                </div>
                <div className="input-group mb-2">
                  <span className="input-group-text">₹</span>
                  <Form.Control
                    type="number"
                    value={makingAmount}
                    onFocus={() => setIsTypingMaking(true)}
                    onBlur={() => setIsTypingMaking(false)}
                    onChange={(e) => {
                      const amount = e.target.value;
                      setMakingAmount(amount);

                      const rate = parseFloat(productForm.purchaseRate);
                      if (!rate || rate <= 0) return;

                      const percent = (amount * 100) / rate;

                      handleChange({
                        target: {
                          name: "makingCharge",
                          value: percent.toFixed(2),
                        },
                      });
                    }}
                  />
                </div>
              </div>
            </Form.Group>
          </Col>
          <Col md={4} className="mb-2">
            <Form.Group>
              <Form.Label>{"Wastage Charge"}</Form.Label>
              <div className="d-flex gap-2">
                <div className="input-group mb-2">
                  <Form.Control
                    type="text"
                    value={productForm.wastageCharge}
                    name="wastageCharge"
                    onChange={handleChange}
                    required
                  />
                  <span className="input-group-text">%</span>
                </div>
                <div className="input-group mb-2">
                  <span className="input-group-text">₹</span>
                  <Form.Control
                    type="number"
                    value={wastageAmount}
                    onFocus={() => setIsTypingWastage(true)}
                    onBlur={() => setIsTypingWastage(false)}
                    onChange={(e) => {
                      const amount = e.target.value;
                      setWastageAmount(amount);

                      const rate = parseFloat(productForm.purchaseRate);
                      if (!rate || rate <= 0) return;

                      const percent = (amount * 100) / rate;

                      handleChange({
                        target: {
                          name: "wastageCharge",
                          value: percent.toFixed(2),
                        },
                      });
                    }}
                  />
                </div>
              </div>
            </Form.Group>
          </Col>
          <Col md={4} className="mb-2">
            <Form.Group>
              <Form.Label>{"Purity"}</Form.Label>
              <Form.Select
                type="text"
                value={productForm.purity}
                name="purity"
                onChange={handleChange}
                required
                >
                  <option value="">Select Gold Value</option>
                  <option value="22k">22k</option>
                  <option value="24k">24k</option>

                </Form.Select>
            </Form.Group>
          </Col>
          <Col md={4} className="mb-2">
            <Form.Group>
              <Form.Label>{"Status"}</Form.Label>
              <Form.Select
                value={productForm.status}
                name="status"
                onChange={handleChange}
                required
              >
                <option value="">Select Status</option>
                <option value="active">Active</option>
                <option value="in active">In Active</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={4} className="mb-2">
            <Form.Group>
              <Form.Label>{"Stock Availability"}</Form.Label>
              <Form.Select
                value={
                  productForm.status === "in active"
                    ? "no"
                    : productForm.stockAvailability
                }
                name="stockAvailability"
                onChange={handleChange}
                required
              >
                <option value="">Select Option</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={4} className="mb-2">
            <Form.Group>
              <Form.Label>{"Gst"}</Form.Label>
              <div className="input-group mb-2">
                <Form.Control
                  type="text"
                  value={productForm.gst}
                  name="gst"
                  onChange={handleChange}
                  required
                />
                <span className="input-group-text">%</span>
              </div>
            </Form.Group>
          </Col>
          <Col md={4} className="mb-2">
            <Form.Group>
              <Form.Label>{"Discount"}</Form.Label>

              <div className="input-group mb-2">
                <Form.Control
                  type="text"
                  value={productForm.discount}
                  name="discount"
                  onChange={handleChange}
                  required
                />
                <span className="input-group-text">%</span>
              </div>
            </Form.Group>
          </Col>
          <Col md={4} className="mb-2">
            <Form.Group>
              <Form.Label>{"PurChase Gold Rate"}</Form.Label>
              <Form.Control
                type="text"
                value={productForm.purchaseGoldRate}
                name="purchaseGoldRate"
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
          <Col md={4} className="mb-2">
            <Form.Group>
              <Form.Label>{"Purchase Date"}</Form.Label>
              <Form.Control
                type="date"
                value={productForm.purchaseDate}
                name="purchaseDate"
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
          <Col md={4} className="mb-2">
            <Form.Group>
              <Form.Label>Vendor</Form.Label>
              <Form.Select
                value={productForm.vendorId}
                name="vendorId"
                onChange={handleChange}
                required
              >
                <option value="">Select Vendor</option>
                {vendors
                  .filter((vendor) => vendor.status?.toLowerCase() === "active")
                  .map((vendor) => (
                    <option key={vendor.id} value={vendor.id}>
                      {vendor.name}
                    </option>
                  ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={4} className="mb-2">
            <Form.Group>
              <Form.Label>Category</Form.Label>
              <Form.Select
                value={productForm.categoryId}
                name="categoryId"
                onChange={handleChange}
                required
              >
                <option value="">Select Category</option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={4} className="mb-2">
            <Form.Group>
              <Form.Label>Product Type</Form.Label>
              <Form.Select
                value={productForm.productType}
                name="productType"
                onChange={handleChange}
                required
              >
                <option value="">Select Product Type</option>
                <option value="general">General</option>
                <option value="men">Men</option>
                <option value="woman">Woman</option>
                <option value="kids">Kids</option>
                <option value="weddings">weddings</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={8} className="mb-2">
            <Form.Group>
              <Form.Label>{"Description"}</Form.Label>
              <Form.Control
                as={"textarea"}
                rows={"3"}
                type="text"
                value={productForm.description}
                name="description"
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>

          {/* ============ IMAGE UPLOAD SECTION ============ */}
          <Col md={12} className="mb-4">
            <div className="image-upload-section p-3 border rounded bg-light">
              <h6 className="mb-3 fw-bold text-primary">Product Images</h6>
              <div className="d-flex align-items-center mb-3">
                <label
                  htmlFor="imageUpload"
                  className="btn btn-outline-primary me-2 px-4 py-2 rounded-pill"
                >
                  <i className="bi bi-plus-circle me-1"></i> Add Image
                </label>
                <input
                  id="imageUpload"
                  type="file"
                  multiple
                  accept="image/*"
                  onChange={handleImageChange}
                  style={{ display: "none" }}
                />
                <small className="text-muted">
                  {images?.length} image{images?.length !== 1 && "s"} selected
                </small>
              </div>
              <div className="text-danger mb-2" style={{ fontSize: "13px" }}>
                Please upload images in JPG or PNG format with a recommended
                size of 255px X 255px.
              </div>

              {/* Image Previews */}
              {images?.length > 0 && (
                <Row className="g-2 mt-2">
                  {images.map((image, index) => {
                    let src, label;

                    if (image instanceof File) {
                      // It's a newly added file
                      src = URL.createObjectURL(image);
                      label = image.name;
                    } else {
                      // It's an existing image object from DB
                      src = `${apiUrl}/${image.imageUrl}`;
                      label = `Image - ${index + 1}`;
                    }

                    return (
                      <Col
                        xs={6}
                        sm={4}
                        md={3}
                        lg={2}
                        key={index}
                        className="position-relative"
                      >
                        <div className="image-preview border rounded overflow-hidden position-relative shadow-sm">
                          <img
                            src={src}
                            alt={`preview-${label}`}
                            className="img-fluid"
                            style={{
                              height: "100px",
                              objectFit: "cover",
                              width: "100%",
                            }}
                          />
                          <button
                            type="button"
                            className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1 rounded-circle"
                            onClick={() => removeImage(image)}
                            style={{
                              width: "24px",
                              height: "24px",
                              padding: 0,
                            }}
                            title="Remove image"
                          >
                            <i
                              className="bi bi-x"
                              style={{ fontSize: "10px" }}
                            ></i>
                          </button>
                        </div>
                        <div
                          className="text-truncate mt-1"
                          style={{ fontSize: "0.8rem" }}
                        >
                          {label.length > 15
                            ? label.substring(0, 15) + "..."
                            : label}
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              )}
            </div>
          </Col>
        </Row>

        <div className="d-flex justify-content-end">
          <Button
            type="button"
            className="custom-btn me-2"
            onClick={handleClearChange}
          >
            Clear
          </Button>
          <Button type="submit" className="custom-btn1">
            {editIndex !== null ? "Update" : "Submit"}
          </Button>
        </div>
      </Form>
    </>
  );
};

export default ProductForm;
